import { useSelector } from 'react-redux';
import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import EventTableService from '../service/EventTableService';
import EventSeverity from '../dto/EventSeverity';

const config = data => {
	return {
		key: 'eventTable',
		text: 'Event',
		service: EventTableService,
		toolbarAction: ['filter', 'search', 'refresh', 'export'],
		exportList: sessionName => `${nBossConnection.basePath}eventTableControl/exportXlsx?session=${sessionName}`,
		editFormState: item => `/event/edit/${item ? item.id : 'new'}`,
		filterFields: [
			{
				propertyName: 'text',
				text: 'Text',
				propertyType: 'String',
				type: 'LIKE'
			},
			{
				propertyName: 'project',
				text: 'Project',
				propertyType: 'Long',
				type: 'IN',
				visibleIf: () => data.user.isSuperAdmin
			},
			{
				propertyName: 'device.name',
				text: 'Device',
				propertyType: 'String',
				type: 'LIKE'
			},
			{
				propertyName: 'severity',
				text: 'Severity',
				propertyType: 'String',
				type: 'IN',
				items: () =>
					Object.keys(EventSeverity).map(s => {
						return { value: s, label: EventSeverity[s] };
					})
			}
		],
		rowAction: ['modify', 'delete'],
		columns: [
			{
				key: 'project.name',
				text: 'Project',
				textKey: 'project.name',
				type: 'text',
				sortable: true,
				visibleIf: () => data.user.isSuperAdmin,
				disablePadding: false
			},
			{
				key: 'timestamp',
				text: 'Timestamp',
				type: 'dateTime',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'text',
				text: 'Text',
				type: 'text',
				sortable: false,
				disablePadding: false
			},
			{
				key: 'severity',
				text: 'Severity',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'device.name',
				text: 'Device',
				type: 'text',
				sortable: true,
				disablePadding: false
			}
		]
	};
};

function EventTable() {
	const user = useSelector(({ auth }) => auth.user);
	const myConfig = config({ user });

	return <TableBrowser config={myConfig} />;
}

export default withReducer('eventTable', reducer('eventTable'))(EventTable);
